import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { withGridState } from './withGridState'

export { REDUCER_NAME, getSelectedRow, reducer, saga, destroyInstance as destroy, getLKGrid } from './store'

export { withGridState }

export default Loadable(() => import('./LKGrid'))
